module.exports = __webpack_public_path__ + "static/img/produce-global.1255a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/taxcellent/produce-global.png
// module id = 6w8U
// module chunks = 34